import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { getExtensionWithoutDotFromFileName } from 'owa-file';
import fileExtensionToOfficeFileType from 'owa-file/lib/utils/fileExtensionToOfficeFileType';
import type AttachmentId from 'owa-service/lib/contract/AttachmentId';

export function isOfficeFile(attachmentId: AttachmentId): boolean {
    const attachment = getAttachment(attachmentId);
    const extension = getExtensionWithoutDotFromFileName(attachment.model.Name || '');

    // Exclude visio files.
    return (
        fileExtensionToOfficeFileType(extension) !== '' &&
        fileExtensionToOfficeFileType(extension) !== 'Visio'
    );
}
